// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperSideNav_root__3ziU0","tabs":"LayoutWrapperSideNav_tabs__36ztQ","tab":"LayoutWrapperSideNav_tab__1tP-I"};